var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    transform: "scale(-1,1)",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.61059 5.49016L9.29952 7.17953L11.523 6.57371L12.229 7.27973L9.04768 9.0492L7.27971 12.2307L6.57219 11.5232L7.17861 9.30059L5.48924 7.61122L4.22989 12.2307L2.72936 10.7297V4.85149L0.668898 2.79058C0.0830236 2.20515 0.0830236 1.25599 0.668898 0.670119C1.25447 0.0842443 2.20453 0.0842443 2.79041 0.670119L4.85101 2.73058H10.7291L12.229 4.23051L7.61059 5.49016ZM4.97924 5.68611L7.88687 8.59419L8.59439 7.88667L5.68691 4.97845L10.264 3.7305H4.43807L2.08557 1.3771C1.89013 1.18196 1.57334 1.18196 1.37895 1.3762C1.18366 1.57194 1.18321 1.88993 1.37805 2.08372L3.73085 4.43757L3.7313 10.263L4.97924 5.68611Z",
    fill: "#2A71DB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.25a42a2b.svg";
export { ForwardRef as ReactComponent };